// staffFeaturesPathMap.js
export const staffFeaturesPathMap = {
    "default": [
        "/practice/dashboard",
        "/staff/account",
        "/practice/patient/report",
        "/practice/patient/report/trait",
        "/practice/patient/report/diagram",
        "/practice/patient/report/supplemental_genotype",
        "/practice/patient/report/ps_list/:ps_list_id",
        "/practice/report/new/:report_id",
        "/practice/patient/past_report"
    ],
    // Patient
    "Patient.read": ["/practice/patients"],
    "Patient.create": ["/practice/patient/add"],
    "Patient.manage": [
        "/practice/patients",
        "/practice/patient/add"
    ],

    // Recommendations
    "ViewingRecommendations.read": ["/practice/supplement_catalog"],
    "ViewingRecommendations.create": ["/practice/supplement_catalog"], // same page
    "ViewingRecommendations.manage": ["/practice/supplement_catalog"], // same page

    // Catalogue
    "ViewingTheCatalogue.read": ["/practice/patient/catalog"],
    "ViewingTheCatalogue.create": ["/practice/patient/catalog"],
    "ViewingTheCatalogue.manage": ["/practice/patient/catalog"],

    // Genetic Files
    "UploadingPatientGeneticFiles.read": ["/practice/patient/snp"],
    "UploadingPatientGeneticFiles.create": ["/practice/patient/snp"],
    "UploadingPatientGeneticFiles.manage": ["/practice/patient/snp"],

    // Lab Files
    "UploadingPatientLabFiles.read": [
        "/practice/patient/lab",
        "/practice/patient/lab/review",
        "/practice/patient/lab/manual_entry"
    ],
    "UploadingPatientLabFiles.create": [
        "/practice/patient/lab",
        "/practice/patient/lab/review",
        "/practice/patient/lab/manual_entry"
    ],
    "UploadingPatientLabFiles.manage": [
        "/practice/patient/lab",
        "/practice/patient/lab/review",
        "/practice/patient/lab/manual_entry"
    ]
};
